export const getCamStudyV2HomeUrl = function () {
    if (process.env.NODE_ENV === 'local') {
        return '/';
    }

    const rootUrl = process.env.VUE_APP_V2_ROOT_URL || '';
    const homePath = process.env.VUE_APP_V2_HOME_PATH || '';
    return `${rootUrl}${homePath}` || '/';
}

export const getCamStudyV2RootUrl = function () {
    if (process.env.NODE_ENV === 'local') {
        return '';
    }

    return process.env.VUE_APP_V2_ROOT_URL || '';
}